import { AudioFormat } from '../../device-api/audio-format';
import { VideoColourSpace, VideoFormat } from '../../device-api/video-format';
import { AudioCodecType, UhdHdrCodec, supportsAudioCodec, supportsVideoCodec, probeVideoSupportByMediaCapabilities } from '../../utils/probe-utils';
import { FAIRPLAY_HLS, WIDEVINE_DASH } from '../../device-api/playout-capability';
export class BrowserCapabilities {
    isSafari;
    constructor(isSafari) {
        this.isSafari = isSafari;
    }
    hasLowerEndSpecs() {
        return false;
    }
    requiresLicensingSigning() {
        return true;
    }
    hasThumbnailScrubbingSupport() {
        return true;
    }
    hasExtendedDvrSupport() {
        return true;
    }
    supportsExtendedDvrOnIsp() {
        return true;
    }
    prefersHttp() {
        return false;
    }
    getHardwareCapabilities() {
        const codec = UhdHdrCodec.Hdr10;
        const isUhdHdrSupported = supportsVideoCodec(codec);
        return this.getSupportedColourSpaces(isUhdHdrSupported, codec).then((colourSpaces) => ({
            videoFormat: VideoFormat.HD,
            audioFormats: this.getSupportedAudioFormats(isUhdHdrSupported),
            colourSpaces,
        }));
    }
    async getSupportedColourSpaces(isUhdHdrSupported, codec) {
        const colourSpaces = [VideoColourSpace.SDR];
        if (isUhdHdrSupported) {
            const isHdr10Supported = await probeVideoSupportByMediaCapabilities(codec);
            if (isHdr10Supported) {
                colourSpaces.push(VideoColourSpace.HDR10);
            }
        }
        const isDolbyVisionSupported = supportsVideoCodec(UhdHdrCodec.DolbyVision);
        if (isDolbyVisionSupported) {
            colourSpaces.push(VideoColourSpace.DV);
        }
        return colourSpaces;
    }
    getSupportedAudioFormats(isUhdHdrSupported) {
        const audioFormats = [AudioFormat.Stereo];
        if (isUhdHdrSupported) {
            if (supportsAudioCodec(AudioCodecType.DolbyDigital)) {
                audioFormats.push(AudioFormat.Dolby51);
            }
            if (supportsAudioCodec(AudioCodecType.DolbyDigitalPlus)) {
                audioFormats.push(AudioFormat.Dolby71, AudioFormat.DolbyAtmos);
            }
        }
        return audioFormats;
    }
    getPlayoutCapabilities() {
        if (this.isSafari) {
            return { default: FAIRPLAY_HLS };
        }
        return { default: WIDEVINE_DASH };
    }
}
//# sourceMappingURL=browser-capabilities.js.map